
import { useEffect, useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Game } from '@/types/game';

export const useGamePresence = (game: Game | undefined) => {
  const gameInfoForPresence = useMemo(() => {
    if (!game) return null;
    return { id: game.id, title: game.title };
  }, [game?.id, game?.title]);

  useEffect(() => {
    if (!gameInfoForPresence) return;

    let channel: any = null;

    const setupGamePresence = async () => {
      try {
        const channelName = 'gamehub-live-activity';
        channel = supabase.channel(channelName);

        channel.subscribe(async (status: string) => {
          if (status === 'SUBSCRIBED') {
            const payload = {
              gameId: gameInfoForPresence.id,
              gameTitle: gameInfoForPresence.title,
              path: window.location.pathname,
            };
            await channel.track(payload);
          }
        });
      } catch (error) {
        // Silently handle connection errors - don't log for security
      }
    };

    setupGamePresence();

    return () => {
      if (channel) {
        try {
          supabase.removeChannel(channel);
        } catch (error) {
          // Silently handle cleanup errors
        }
      }
    };
  }, [gameInfoForPresence]);
};
